import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Box, Typography } from "@mui/material";
import Loading from "../../../../../components/loading/loading";
import { getCurrentCoverageAreasRequest } from "../../../../../redux/inspection-firms/slice";
import CoverageTable from "../../../inspection-firms/inspection-firm-details/coverage-area/CoverageTable";
// import CoverageTable from "./CoverageTable";

const CoverageArea = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrentCoverageAreasRequest());
  }, [dispatch]);

  const { loading, currentCoverageAreas } = useSelector(
    (state: any) => state.inspectionFirms
  );

  return (
    <Box sx={{ my: 3 }}>
      {currentCoverageAreas?.length > 0 &&
        currentCoverageAreas.map((area: any) => (
          <Card className="card-layout">
            <Box className="card-header">
              <Typography variant="h5">{area?.displayName}</Typography>
            </Box>
            <Box className="display-name-layout">
              <Typography className="label-txt">Coverage Area</Typography>
              <CoverageTable area={area} />
            </Box>
          </Card>
        ))}

      {loading && <Loading />}
    </Box>
  );
};

export default CoverageArea;
